var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root_page"},[_c('div',{staticClass:"table_wrapper"},[_c('div',{staticClass:"ctrl-wrapper"}),_vm._v(" "),_c('Table',{staticClass:"main_table",attrs:{"size":"large","stripe":"","border":"","height":_vm.clientHeight - 284,"columns":_vm.tableHeader,"data":_vm.tableData},scopedSlots:_vm._u([{key:"answerFormulaPic",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('viewer',{attrs:{"images":[_vm.trackUrl + row.image]}},[_c('img',{staticClass:"track_img",attrs:{"src":_vm.trackUrlItem+ row.answerFormulaPic}})])]}},{key:"replyFormulaPic",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('viewer',{attrs:{"images":[_vm.trackUrl + row.image]}},[_c('img',{staticClass:"track_img",attrs:{"src":_vm.trackUrlItem + row.replyFormulaPic}})])]}},{key:"image",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('viewer',{attrs:{"images":[_vm.trackUrl + row.image]}},[_c('img',{staticClass:"track_img",attrs:{"src":_vm.positionUrl + row.image}})])]}},{key:"lastScore",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('a',{staticClass:"jump_color_score",style:({color:parseInt(row.lastScore) ? '#0f0' : '#f00'})},[_vm._v(_vm._s(parseInt(row.lastScore) ? '√' : '×'))])]}},{key:"action",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',{staticClass:"hanle_click",on:{"click":function($event){return _vm.againScoring(row.id)}}},[_vm._v("打分")])]}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-533eac22","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OCRCardItemDetails.vue
// module id = null
// module chunks = 